export const SEX_TYPES = ['設定なし', '男性', '女性']
export const BLOOD_TYPE_ABO = ['不明', 'A', 'B', 'O', 'AB']
export const BLOOD_TYPE_RH = ['不明', 'RH+', 'RH-']
